import { Share2, LocateFixed } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { setShowShareCalendar } from '../../Redux/store';
import AddTestPictureButton from './AddTestPictureButton';
import './CalendarBottomMenu2.css';

function CalendarBottomMenu2({ calendarId, scrollToToday, isIp, isOwnCalendar }) {
  const dispatch = useDispatch();

  // Show full bottom bar only for IP viewing own calendar
  // Otherwise (donor or viewing someone else's calendar) show only today button
  const showFullBar = isIp && isOwnCalendar;

  if (!showFullBar) {
    return (
      <div className="calendar-bottom-menu-2-donor">
        <div className="calendar-rect-left" onClick={() => dispatch(setShowShareCalendar(true))}>
          <Share2 className="calendar-share-icon" />
          Sharing
        </div>
        <div className="calendar-rect-right" onClick={() => scrollToToday(250, calendarId)}>
          <LocateFixed className="calendar-today-icon" />
          Today
        </div>
      </div>
    );
  }

  // Full bottom bar for IP viewing own calendar
  return (
    <div className="calendar-bottom-menu-2">
      <div className="calendar-bottom-menu-inner">
        <div className="center-circle"></div>
      </div>
      <div className="calendar-bottom-menu-overlay"></div>
      <div className="calendar-rect-left" onClick={() => dispatch(setShowShareCalendar(true))}>
        <Share2 className="calendar-share-icon" />
        Share
      </div>
      <AddTestPictureButton />
      <div className="calendar-rect-right" onClick={() => scrollToToday(250, calendarId)}>
        <LocateFixed className="calendar-today-icon" />
        Today
      </div>
    </div>
  );
}

export default CalendarBottomMenu2;
